import { createAction } from 'redux-actions';

export const getAllOrderProductRequested = createAction('GET_ALL_ORDER_PRODUCT_REQUESTED');
export const getAllOrderProductRequestedReceived = createAction('GET_ALL_ORDER_PRODUCT_REQUESTED_RECEIVED');
export const getAllOrderProductRequestedReceivedFailure = createAction('GET_ALL_ORDER_PRODUCT_REQUESTED_RECEIVED_FAILURE');
export const clearOrderProductData = createAction('CLEAR_ORDER_PRODUCT_DATA');

export const getDetailOrderProductRequested = createAction('GET_DETAIL_ORDER_PRODUCT_REQUESTED');
export const getDetailOrderProductRequestedReceived = createAction('GET_DETAIL_ORDER_PRODUCT_REQUESTED_RECEIVED');
export const getDetailOrderProductRequestedReceivedFailure = createAction('GET_DETAIL_ORDER_PRODUCT_REQUESTED_RECEIVED_FAILURE');
export const clearDetailOrderProductData = createAction('CLEAR_DETAIL_ORDER_PRODUCT_DATA');

export const updateStatusTransactionRequested = createAction('UPDATE_STATUS_TRANSACTION_REQUESTED');
export const updateStatusTransactionRequestedReceived = createAction('UPDATE_STATUS_TRANSACTION_REQUESTED_RECEIVED');
export const updateStatusTransactionRequestedReceivedFailure = createAction('UPDATE_STATUS_TRANSACTION_REQUESTED_RECEIVED_FAILURE');
export const clearStatusTransaction = createAction('CLEAR_STATUS_TRANSACTION');

export const resentMailOrderRequested = createAction('RESENT_MAIL_ORDER_REQUESTED');
export const resentMailOrderRequestedReceived = createAction('RESENT_MAIL_ORDER_REQUESTED_RECEIVED');
export const resentMailOrderRequestedReceivedFailure = createAction('RESENT_MAIL_ORDER_REQUESTED_RECEIVED_FAILURE');
export const clearMailOrder = createAction('CLEAR_MAIL_ORDER');
